import { render, staticRenderFns } from "./DiscountList.vue?vue&type=template&id=391d3c16&scoped=true&"
import script from "./DiscountList.vue?vue&type=script&lang=js&"
export * from "./DiscountList.vue?vue&type=script&lang=js&"
import style0 from "./DiscountList.vue?vue&type=style&index=0&id=391d3c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391d3c16",
  null
  
)

export default component.exports